import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

window.addEventListener('load', () => {
  const sliders = document.querySelectorAll('.wp-block-o-recent-posts .swiper');
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    const container = slider.closest('.o-block__container');
    const prevBtn = container?.querySelector('.custom-swiper-button-prev');
    const nextBtn = container?.querySelector('.custom-swiper-button-next');

    console.log('✅ Swiper init for:', slider);
    console.log('→ prev:', prevBtn);
    console.log('→ next:', nextBtn);

    const swiper = new Swiper(slider, {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 20,
      loop: false,
      centeredSlides: false,
      autoHeight: false,

      breakpoints: {
        0: {
          slidesPerView: 1,
          slidesPerGroup: 1,
        },
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
      },

      on: {
        afterInit: updateButtonStates,
        slideChange: updateButtonStates,
      },
    });

    function updateButtonStates(swiperInstance) {
      if (!prevBtn || !nextBtn) return;

      swiperInstance.isBeginning
        ? prevBtn.classList.add('swiper-button-disabled')
        : prevBtn.classList.remove('swiper-button-disabled');

      swiperInstance.isEnd
        ? nextBtn.classList.add('swiper-button-disabled')
        : nextBtn.classList.remove('swiper-button-disabled');
    }

    // fallback manuel
    prevBtn?.addEventListener('click', () => {
      swiper.slidePrev();
    });

    nextBtn?.addEventListener('click', () => {
      swiper.slideNext();
    });
  });
});
